import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../assets/no-data.png'


const _hoisted_1 = {
  key: 0,
  class: "ma--top-1"
}
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card ma--bottom-1" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-content" }
const _hoisted_10 = {
  key: 0,
  class: "table table--striped"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "15%"
}, "Purchase Date", -1)
const _hoisted_12 = {
  class: "text--align-left",
  width: "10%"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "40%"
}, "Purchased Fields", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "10%"
}, "Status", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "10%"
}, "Credits Used", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "8%"
}, "Actions", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  width: "8%"
}, "Type", -1)
const _hoisted_18 = { class: "text--align-left" }
const _hoisted_19 = {
  key: 0,
  class: "color--primary-green text--style-italic text--size-1-1 text--align-left"
}
const _hoisted_20 = { class: "text--align-left" }
const _hoisted_21 = { class: "text--align-left" }
const _hoisted_22 = { class: "text--align-left" }
const _hoisted_23 = { class: "text--align-left" }
const _hoisted_24 = { class: "text--align-left" }
const _hoisted_25 = {
  key: 0,
  class: "btn--group"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "btn--name"
}
const _hoisted_28 = {
  key: 1,
  class: "btn--name"
}
const _hoisted_29 = { class: "text--align-left" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { colspan: "11" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PurchaseLeads = _resolveComponent("PurchaseLeads")!
  const _component_AdditionalDetails = _resolveComponent("AdditionalDetails")!
  const _component_DownloadFile = _resolveComponent("DownloadFile")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_ctx.response)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.request._loading || _ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.togglePurchaseModel)
                      ? (_openBlock(), _createBlock(_component_PurchaseLeads, {
                          key: 0,
                          selectedLeads: _ctx.leads,
                          purchasedLead: _ctx.purchasedLead,
                          siteId: _ctx.siteId,
                          order: _ctx.selectedOrder,
                          purchaseType: "repurchaseLead",
                          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModel($event))),
                          onPurchase: _ctx.updatePurchaseModel
                        }, null, 8, ["selectedLeads", "purchasedLead", "siteId", "order", "onPurchase"]))
                      : _createCommentVNode("", true),
                    (_ctx.toggleDetailsModel)
                      ? (_openBlock(), _createBlock(_component_AdditionalDetails, {
                          key: 1,
                          details: _ctx.details,
                          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDetailsModel($event)))
                        }, null, 8, ["details"]))
                      : _createCommentVNode("", true),
                    (_ctx.toggleDownloadFileModel)
                      ? (_openBlock(), _createBlock(_component_DownloadFile, {
                          key: 2,
                          onClose: _ctx.onCloseDownloadModel,
                          onDownload: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadFile($event)))
                        }, null, 8, ["onClose"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.response)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_11,
                              _createElementVNode("th", _hoisted_12, " Number of " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() + _ctx.leadName.slice(1)) + "s ", 1),
                              _hoisted_13,
                              _hoisted_14,
                              _hoisted_15,
                              _hoisted_16,
                              _hoisted_17
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.data, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_18, [
                                  (item.status == 'FULLFILLED' && item.creditsUsed > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, "leads available"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$filters.dateDisplay(item.purchaseDate)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$filters.numberDisplay(item.noOfLeads)), 1),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.getFieldNames(item)), 1),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(item.status == "FULLFILLED" ? "READY" : (item.status == "NEW" ?"PROCESSING" : item.status)), 1),
                                _createElementVNode("td", _hoisted_23, [
                                  _createElementVNode("span", null, _toDisplayString(item.creditsUsed), 1)
                                ]),
                                _createElementVNode("td", _hoisted_24, [
                                  (item.status == 'FULLFILLED' || item.status == 'DOWNLOADED')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("a", {
                                          style: _normalizeStyle(item.creditsUsed == 0 ? 'text-decoration:none' : ''),
                                          class: "btn--link color--secondary-blue ma--right-1",
                                          onClick: ($event: any) => (item.creditsUsed > 0 ? _ctx.downloadFileCSV(item.orderId) : null)
                                        }, [
                                          (item.creditsUsed > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Download"))
                                            : _createCommentVNode("", true),
                                          (item.creditsUsed == 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "No Record Available"))
                                            : _createCommentVNode("", true)
                                        ], 12, _hoisted_26)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_29, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getPurchaseType(item)), 1)
                                ])
                              ]))
                            }), 128)),
                            (_ctx.response.length == 0 && !_ctx.request._loading)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_30, _hoisted_32))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.response.pageInfo.totalResults)
                      ? (_openBlock(), _createBlock(_component_Pagination, {
                          key: 1,
                          totalResults: _ctx.response.pageInfo.totalResults,
                          totalPages: _ctx.response.pageInfo.totalPages,
                          showPage: _ctx.response.data.length,
                          page: _ctx.request.page,
                          onApplyPagination: _ctx.controlWithPagination
                        }, null, 8, ["totalResults", "totalPages", "showPage", "page", "onApplyPagination"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}